/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Price_Per_HourInputs */

const en_admin_resource_form_price_per_hour = /** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price per hour (net)`)
};

const de_admin_resource_form_price_per_hour = /** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis pro Stunde`)
};

const es_admin_resource_form_price_per_hour = /** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio por hora`)
};

const fr_admin_resource_form_price_per_hour = /** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix par heure`)
};

/** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */
const it_admin_resource_form_price_per_hour = en_admin_resource_form_price_per_hour;

/** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */
const pt_br2_admin_resource_form_price_per_hour = en_admin_resource_form_price_per_hour;

/** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */
const pl_admin_resource_form_price_per_hour = en_admin_resource_form_price_per_hour;

/** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */
const hu_admin_resource_form_price_per_hour = en_admin_resource_form_price_per_hour;

/** @type {(inputs: Admin_Resource_Form_Price_Per_HourInputs) => LocalizedString} */
const ro_admin_resource_form_price_per_hour = en_admin_resource_form_price_per_hour;

/**
* | output |
* | --- |
* | "Price per hour (net)" |
*
* @param {Admin_Resource_Form_Price_Per_HourInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_price_per_hour = /** @type {((inputs?: Admin_Resource_Form_Price_Per_HourInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Price_Per_HourInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_price_per_hour(inputs)
	if (locale === "de") return de_admin_resource_form_price_per_hour(inputs)
	if (locale === "es") return es_admin_resource_form_price_per_hour(inputs)
	if (locale === "fr") return fr_admin_resource_form_price_per_hour(inputs)
	if (locale === "it") return it_admin_resource_form_price_per_hour(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_price_per_hour(inputs)
	if (locale === "pl") return pl_admin_resource_form_price_per_hour(inputs)
	if (locale === "hu") return hu_admin_resource_form_price_per_hour(inputs)
	return ro_admin_resource_form_price_per_hour(inputs)
});
export { admin_resource_form_price_per_hour as "admin.resource_form.price_per_hour" }